import { render, staticRenderFns } from "./OrderDetailsPanel.vue?vue&type=template&id=0046aff5&scoped=true&"
import script from "./OrderDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsPanel.vue?vue&type=style&index=0&id=0046aff5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046aff5",
  null
  
)

export default component.exports